function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const SOURCE_COLORS = {
    // new palettes, may have duplicates in legacy
    black900: '#000000',
    black800: 'rgb(0 0 0 / 90%)',
    emerald100: '#e3f2f6',
    emerald700: '#0a806b',
    green100: '#e7f3f0',
    green700: '#318643',
    red100: '#fff0f0',
    red400: 'f27373',
    red700: '#d24345',
    yellow100: '#faf1d7',
    yellow700: '#e8b738',
    white900: '#ffffff',
    grey100: '#f8f8f8',
    gray100: '#f8f8f8',
    grey200: '#efefef',
    gray200: '#efefef',
    grey300: '#dfdfdf',
    gray300: '#dfdfdf',
    grey400: '#c4c4c4',
    gray400: '#c4c4c4',
    grey500: '#9e9e9e',
    gray500: '#9e9e9e',
    grey600: '#707070',
    gray600: '#707070',
    grey700: '#5c5c5c',
    gray700: '#5c5c5c',
    grey800: '#313131',
    gray800: '#313131',
    grey900: '#151515',
    gray900: '#151515',
    // legacy palette
    white: '#ffffff',
    black: '#000000',
    charcoal: '#151515',
    graphite: '#313131',
    darkGrey: '#5c5c5c',
    mediumGrey: '#dfdfdf',
    platinum: '#efefef',
    lightGrey: '#f8f8f8',
    oceanBlue: '#44a2dd',
    skyBlue: '#73d2f2',
    lightBlue: '#e3f2f6',
    lightPink: '#fff0f0',
    red: '#d24345',
    mediumGreen: '#318643',
    lightGreen: '#e7f3f0',
    mediumYellow: '#e8b738',
    // rainbow
    scarlet: '#9a0202',
    mandarin: '#b3351a',
    rum: '#c94b2f',
    pumpkin: '#ba5d10',
    caspian: '#204949',
    celtic: '#046240',
    emerald: '#0a806b',
    opal: '#c0e6df',
    talavera: '#2b3b55',
    atlantic: '#16618c',
    kingfisher: '#017eb4',
    rio: '#99d3f3',
    santorini: '#3b5ff3',
    ultramarine: '#3e3cbc',
    iris: '#6655d1',
    violet: '#844cbc',
    // deprecated
    /**
   * @deprecated
   */ brandBlue: '#0075c2',
    /**
   * @deprecated
   */ darkBlue: '#004471',
    /**
   * @deprecated
   */ accentGreen: '#0a806b',
    /**
   * @deprecated
   */ pink: '#e10096'
};
const GLOBAL_FONT = SOURCE_COLORS.black800;
const SEMANTIC_COLORS = {
    globalFont: GLOBAL_FONT,
    border: SOURCE_COLORS.grey300,
    discount: SOURCE_COLORS.emerald700,
    discountBackground: SOURCE_COLORS.green100,
    error: SOURCE_COLORS.red700,
    holiday: SOURCE_COLORS.scarlet,
    // https://vistaprint.atlassian.net/wiki/spaces/DesignSystemTeam/pages/3336211465/Holiday+FY24+-+Color
    holidayBeige1: '#ede3cf',
    holidayGreen1: '#318750',
    holidayGreen2: '#06462E',
    holidayRed1: '#A5030B',
    holidayRed2: '#A5030B',
    icon: SOURCE_COLORS.grey900,
    link: GLOBAL_FONT,
    selected: SOURCE_COLORS.black900
};
const MARKETING_COLORS = {
    atlantic: SOURCE_COLORS.atlantic,
    caspian: SOURCE_COLORS.caspian,
    celtic: SOURCE_COLORS.celtic,
    darkGrey: SOURCE_COLORS.grey700,
    emerald: SOURCE_COLORS.emerald700,
    graphite: SOURCE_COLORS.grey800,
    holidayBeige1: SEMANTIC_COLORS.holidayBeige1,
    holidayGreen1: SEMANTIC_COLORS.holidayGreen1,
    holidayGreen2: SEMANTIC_COLORS.holidayGreen2,
    holidayRed1: SEMANTIC_COLORS.holidayRed1,
    holidayRed2: SEMANTIC_COLORS.holidayRed2,
    kingfisher: SOURCE_COLORS.kingfisher,
    mediumGreen: SOURCE_COLORS.green700,
    mediumGrey: SOURCE_COLORS.grey300,
    opal: SOURCE_COLORS.opal,
    platinum: SOURCE_COLORS.grey200,
    rio: SOURCE_COLORS.rio,
    talavera: SOURCE_COLORS.talavera
};
const MARKETING_BACKGROUNDS = {
    atlantic: 'atlantic',
    black900: 'black-900',
    caspian: 'caspian',
    celtic: 'celtic',
    darkGrey: 'dark-grey',
    emerald: 'emerald',
    graphite: 'graphite',
    holidayBeige1: 'holiday-beige-1',
    holidayGreen1: 'holiday-green-1',
    holidayGreen2: 'holiday-green-2',
    holidayRed1: 'holiday-red-1',
    holidayRed2: 'holiday-red-2',
    kingfisher: 'kingfisher',
    mediumGreen: 'medium-green',
    mediumGrey: 'medium-grey',
    opal: 'opal',
    platinum: 'platinum',
    rio: 'rio',
    rum: 'rum',
    talavera: 'talavera'
};
const BACKGROUNDS = _object_spread_props(_object_spread({}, MARKETING_BACKGROUNDS), {
    black: 'black',
    black900: 'black-900',
    darkBlue: 'dark-blue',
    darkGray: 'dark-gray',
    discount: 'discount',
    emerald100: 'emerald-100',
    emerald700: 'emerald-700',
    green100: 'green-100',
    green700: 'green-700',
    gray100: 'gray-100',
    grey100: 'grey-100',
    grey200: 'grey-200',
    gray200: 'gray-200',
    grey300: 'grey-300',
    gray300: 'gray-300',
    grey400: 'grey-400',
    gray400: 'gray-400',
    grey500: 'grey-500',
    gray500: 'gray-500',
    grey600: 'grey-600',
    gray600: 'gray-600',
    grey700: 'grey-700',
    gray700: 'gray-700',
    grey800: 'grey-800',
    gray800: 'gray-800',
    grey900: 'grey-900',
    gray900: 'gray-900',
    holiday: 'holiday',
    iris: 'iris',
    lightBlue: 'light-blue',
    lightGray: 'light-gray',
    lightGrey: 'light-grey',
    loadingShimmer: 'loading-shimmer',
    mandarin: 'mandarin',
    mediumGray: 'medium-gray',
    mediumYellow: 'medium-yellow',
    pumpkin: 'pumpkin',
    rum: 'rum',
    santorini: 'santorini',
    scarlet: 'scarlet',
    ultramarine: 'ultramarine',
    violet: 'violet',
    white: 'white',
    white900: 'white-900',
    yellow700: 'yellow-700',
    transparent: 'transparent'
});
const TEXT_COLORS = {
    /**
   * @deprecated use `error` or `warning` color, or `AlertBox` component, instead
   */ alert: 'alert',
    /**
   * @deprecated use black-800 instead
   */ black: 'black',
    black800: 'black-800',
    error: 'error',
    /**
   * @deprecated use grey-700 instead
   */ darkGrey: 'dark-grey',
    /**
   * @deprecated use grey-700 instead
   */ darkGray: 'dark-gray',
    grey700: 'grey-700',
    gray700: 'gray-700',
    holiday: 'holiday',
    warning: 'warning',
    white: 'white'
};
/**
 * Specifies whether an element should have light or dark mode (or either) enabled when using the specified color as its background color.
 * This is used most commonly with hero components
 */ const BACKGROUND_WITH_MODE = {
    atlantic: {
        lightMode: false,
        darkMode: true
    },
    'black-900': {
        lightMode: false,
        darkMode: true
    },
    black: {
        lightMode: false,
        darkMode: true
    },
    caspian: {
        lightMode: false,
        darkMode: true
    },
    celtic: {
        lightMode: false,
        darkMode: true
    },
    'dark-blue': {
        lightMode: false,
        darkMode: true
    },
    'dark-gray': {
        lightMode: false,
        darkMode: true
    },
    'dark-grey': {
        lightMode: false,
        darkMode: true
    },
    discount: {
        lightMode: true,
        darkMode: false
    },
    'emerald-100': {
        lightMode: true,
        darkMode: false
    },
    'emerald-700': {
        lightMode: false,
        darkMode: true
    },
    emerald: {
        lightMode: false,
        darkMode: true
    },
    graphite: {
        lightMode: false,
        darkMode: true
    },
    'gray-100': {
        lightMode: true,
        darkMode: false
    },
    'gray-200': {
        lightMode: true,
        darkMode: false
    },
    'gray-300': {
        lightMode: true,
        darkMode: false
    },
    'gray-400': {
        lightMode: true,
        darkMode: false
    },
    'gray-500': {
        lightMode: true,
        darkMode: false
    },
    'gray-600': {
        lightMode: false,
        darkMode: true
    },
    'gray-700': {
        lightMode: false,
        darkMode: true
    },
    'gray-800': {
        lightMode: false,
        darkMode: true
    },
    'gray-900': {
        lightMode: false,
        darkMode: true
    },
    'green-100': {
        lightMode: true,
        darkMode: false
    },
    'green-700': {
        lightMode: false,
        darkMode: true
    },
    'grey-100': {
        lightMode: true,
        darkMode: false
    },
    'grey-200': {
        lightMode: true,
        darkMode: false
    },
    'grey-300': {
        lightMode: true,
        darkMode: false
    },
    'grey-400': {
        lightMode: true,
        darkMode: false
    },
    'grey-500': {
        lightMode: true,
        darkMode: false
    },
    'grey-600': {
        lightMode: false,
        darkMode: true
    },
    'grey-700': {
        lightMode: false,
        darkMode: true
    },
    'grey-800': {
        lightMode: false,
        darkMode: true
    },
    'grey-900': {
        lightMode: false,
        darkMode: true
    },
    holiday: {
        lightMode: false,
        darkMode: true
    },
    'holiday-beige-1': {
        lightMode: true,
        darkMode: false
    },
    'holiday-green-1': {
        lightMode: false,
        darkMode: true
    },
    'holiday-green-2': {
        lightMode: false,
        darkMode: true
    },
    'holiday-red-1': {
        lightMode: false,
        darkMode: true
    },
    'holiday-red-2': {
        lightMode: false,
        darkMode: true
    },
    iris: {
        lightMode: false,
        darkMode: true
    },
    kingfisher: {
        lightMode: false,
        darkMode: true
    },
    'light-blue': {
        lightMode: true,
        darkMode: false
    },
    'light-gray': {
        lightMode: true,
        darkMode: false
    },
    'light-grey': {
        lightMode: true,
        darkMode: false
    },
    'loading-shimmer': {
        lightMode: true,
        darkMode: false
    },
    mandarin: {
        lightMode: false,
        darkMode: true
    },
    'medium-gray': {
        lightMode: true,
        darkMode: false
    },
    'medium-green': {
        lightMode: false,
        darkMode: true
    },
    'medium-grey': {
        lightMode: true,
        darkMode: false
    },
    'medium-yellow': {
        lightMode: true,
        darkMode: false
    },
    opal: {
        lightMode: true,
        darkMode: false
    },
    platinum: {
        lightMode: true,
        darkMode: false
    },
    pumpkin: {
        lightMode: false,
        darkMode: true
    },
    rio: {
        lightMode: true,
        darkMode: false
    },
    rum: {
        lightMode: false,
        darkMode: true
    },
    santorini: {
        lightMode: false,
        darkMode: true
    },
    scarlet: {
        lightMode: false,
        darkMode: true
    },
    talavera: {
        lightMode: false,
        darkMode: true
    },
    ultramarine: {
        lightMode: false,
        darkMode: true
    },
    violet: {
        lightMode: false,
        darkMode: true
    },
    'white-900': {
        lightMode: true,
        darkMode: false
    },
    white: {
        lightMode: true,
        darkMode: false
    },
    'yellow-700': {
        lightMode: true,
        darkMode: false
    },
    transparent: {
        lightMode: false,
        darkMode: true
    }
};

export { BACKGROUNDS, BACKGROUND_WITH_MODE, GLOBAL_FONT, MARKETING_BACKGROUNDS, MARKETING_COLORS, SEMANTIC_COLORS, SOURCE_COLORS, TEXT_COLORS };
